import { queryOptions } from '@tanstack/react-query';
import { getPerformanceTrendFunction } from './getPerformanceTrendQueryFunction';
import { GetPerformanceTrendQueryParamsType } from './getPerformanceTrendQuery.type';

export const getPerformanceTrendQueryOptions = (
  params: GetPerformanceTrendQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['PerformanceTrend', params],
    queryFn: () => getPerformanceTrendFunction(params),
  });
};
